if(!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    constructor() {
      super();

      this.elSubheading = this.querySelector('[data-variant-subheading]');
      this.elQuickAdd = this.querySelector('quick-add');

      document.addEventListener('variant:changed', this.updateVariant.bind(this))
    }

    updateVariant({ detail }) {
      const { variant, sellingPlan } = detail;
      console.log(variant, sellingPlan);

      this.elQuickAdd.setAttribute('subscription', sellingPlan.id ? sellingPlan.id : '');
      this.elQuickAdd.setAttribute('variant-id', variant.id);

      this.elSubheading.innerHTML = `${variant.title == 'Default Title' ? '' : `${variant.title}, `}${sellingPlan.title}`;
    }
  }
  customElements.define('sticky-atc', StickyAtc);
}